/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import { faChevronDown } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import queryString from "query-string"
import { useEffect, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"

import { showInfoToast } from "../../../components/CustomToast"
import { useDispatch } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import SyuyoninusiService from "../../../service/master/syuyoninusi/syuyoninusiService"
import {
  TSyuyoNinusiListGetReq,
  TSyuyoNinusiListGetRes,
  TSyuyoNinusiListPutReq,
} from "../../../service/master/syuyoninusi/TSyuyoNinusi"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"

import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import ComboBox from "../../../components/ComboBox"
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import NinusiSearchModal from "../../../components/SearchModal/NinusiSearchModal"
import BusyoService from "../../../service/master/busyo/busyoService"
import { e主要荷主 } from "../../../constant/enum/frontend"
import _ from "lodash"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import { nameofT } from "../../../ts/util/typeUtil"
import { TApiResponse } from "../../../service/TApiResponse"

//#region [type]
export type T主要荷主入力Item = TSyuyoNinusiListGetRes & {
  エラーフラグ: number
  行ID: symbol
}
//#endregion

/**
 * 主要荷主マスタ
 * @returns
 */
const MasterSyuyoNinusiRegister = () => {
  const history = useHistory()
  const location = useLocation()

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  // let gridId = "mastersyuyoninusiregister_GridId"

  //#region [baseMethod]
  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<T主要荷主入力Item>) => {
    return new wjCore.CollectionView(data, {})
  }
  // #endoregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([]),
  })

  // 削除アイテムリスト
  const [gridDataDeleteList, setGridDataDeleteList] =
    useState<TSyuyoNinusiListGetRes[]>()
  const [pageSize, setPageSize] = useState<number>(10)

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  const [選択行, set選択行] = useState<wjcGrid.Row>()
  const [is荷主検索Modal, setIs荷主検索Modal] = useState(false)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 登録ボタン制御
  const [isSubmitButton, setIsSubmitButton] = useState(false) // 検索後

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const disPatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  // errorフラグ
  const [hasSearched, setHasSearched] = useState(false)
  const [Form外エラーメッセージList] = useState<string[]>([])
  //grid内エラー項目格納Array
  const [errorCellPositionList] = useState<
    Array<{ 行ID: symbol; colBinding: string }>
  >([])
  //#endregion

  //#region [state]
  // ComboBoxState

  const [部所コード, set部所コード] = useState<string | null>()
  const [, set部所] = useState<T部所マスタ | null>()
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    T部所マスタ["部所コード"],
    T部所マスタ
  > | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)

  //#endregion

  //#region [method]

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TSyuyoNinusiListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    disPatch(clearAlert()) // アラートを非表示に
    setIsSubmitButton(false)

    // 削除用リストを初期化
    let clearList: T主要荷主入力Item[] = []
    setGridDataDeleteList(clearList)

    let currentSearchCondition: TSyuyoNinusiListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new SyuyoninusiService().getList(currentSearchCondition)

      // 削除用リストを作成する
      let copyListSyuyoNinusi: TSyuyoNinusiListGetRes[] = []
      res.data.forEach((d) => {
        // DeepCopy
        copyListSyuyoNinusi.push(_.cloneDeep(d))
      })
      setGridDataDeleteList(copyListSyuyoNinusi)
      // }

      // データ集約用のリスト
      const baseItemList: T主要荷主入力Item[] = []

      // 検索結果をセットする
      res.data.forEach((d) => {
        // DeepCopy
        baseItemList.push(
          _.cloneDeep({
            主要荷主ID: d.主要荷主ID,
            部所ID: d.部所ID,
            部所コード: d.部所コード,
            部所名: d.部所名,
            荷主ID: d.荷主ID,
            荷主コード: d.荷主コード,
            荷主名: d.荷主名,
            削除フラグ: 0,
            更新日時: d.更新日時,
            エラーフラグ: 0,
            行ID: Symbol(),
          })
        )
      })

      // 最大件数分まで行データを追加
      for (let i = baseItemList.length; i < e主要荷主.荷主数; i++) {
        const items: T主要荷主入力Item = {
          主要荷主ID: undefined,
          部所ID: undefined,
          部所コード: 部所コード!,
          部所名: "",
          荷主ID: undefined,
          荷主コード: "",
          荷主名: "",
          削除フラグ: 0,
          更新日時: "",
          エラーフラグ: 0,
          行ID: Symbol(),
        }
        baseItemList.push(items)
      }
      // 最大件数分のデータを初期設定する
      setGridData({ data: createCollectionView(baseItemList) })
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
      setIsSubmitButton(true)
      flexGrid?.refresh()
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TSyuyoNinusiListGetReq = queryString.parse(location.search)
    set部所コード(query.部所コード)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TSyuyoNinusiListGetReq => {
    return {
      部所コード: 部所コード ?? "",
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TSyuyoNinusiListGetReq
  ) => {
    return {
      部所コード,
    }
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    // TODO:検索時に検索済みフラグ作ってGridのIsReadOnlyのプロパティに充てる
    setFlexGrid(grid)
    grid.cellEditEnded.addHandler(cellEditEnded)
    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      if (e.getColumn().binding !== null && e.getRow().dataIndex !== -1) {
        let isExistData = true
        const rowData: T主要荷主入力Item = e.getRow().dataItem
        if (errorCellPositionList.find((e) => e.行ID === rowData.行ID)) {
          isExistData = false
        }
        wjCore.toggleClass(e.cell, "data-warning", !isExistData)
      }
    }
  }

  /**
   * セル編集完了時イベント
   */
  const cellEditEnded = (
    s: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    let col = s.columns[e.col]
    if (e.cancel === true) {
      return
    }
    let rowItem: T主要荷主入力Item = e.getRow().dataItem

    switch (col.binding as keyof T主要荷主入力Item) {
      case nameofT<T主要荷主入力Item>("荷主コード"):
        //TODO:AutoCompleteじゃないので空以外はエラー出ない
        // コード削除で名称を空にする
        if (rowItem.荷主コード === "") {
          rowItem.荷主名 = ""
        }
        break
      default:
        break
    }
  }

  const beforeSubmit = () => {
    // バリデーションチェック
    if (!isValidationCheck()) return

    setIsConfirmModalShow(true)
  }

  const submit = async () => {
    try {
      // DB更新用リスト
      let dataList: Array<TSyuyoNinusiListPutReq> = []

      // 入力Gridを全て新規データとしてセットする
      gridData.data.items.forEach((d: T主要荷主入力Item) => {
        // 荷主コードがある場合、新規データを作成する
        if (d.荷主コード) {
          let data: TSyuyoNinusiListPutReq = {
            主要荷主ID: undefined,
            部所コード: d.部所コード,
            荷主コード: d.荷主コード,
            削除フラグ: 0,
            更新日時: undefined,
          }
          dataList.push(data)
        }
      })

      // 既存データを削除リストとしてセット
      gridDataDeleteList?.forEach((d: TSyuyoNinusiListGetRes) => {
        // 削除フラグを１にして追加
        let data: TSyuyoNinusiListPutReq = {
          主要荷主ID: d.主要荷主ID,
          部所コード: d.部所コード,
          荷主コード: d.荷主コード,
          削除フラグ: 1,
          更新日時: d.更新日時,
        }
        dataList.push(data)
      })

      const service = new SyuyoninusiService()

      let res: TApiResponse<boolean>

      // 更新対象のリストをServiceに渡す
      res = await service.put(dataList)

      disPatch(setAlerts(res))
      if (res) {
        showInfoToast(`主要荷主マスタの更新が完了しました。`)
      }
      // 遷移してきた際のクエリパラメータで検索条件を生成
      const querySearchCondition = queryParse()

      // リストア中フラグON
      setIsRestoreSearching(true)

      // 再検索
      search(querySearchCondition).finally(() => {
        disPatch(画面ロック解除())
      })
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
      flexGrid?.refresh()
    }
  }

  /**
   * 登録時チェック
   * @returns
   */
  const isValidationCheck = (): boolean => {
    disPatch(clearAlert())
    Form外エラーメッセージList.splice(0, Form外エラーメッセージList.length)

    let hasError = false
    let messages: Array<string> = []
    let isDetailGridHasFlagError = false

    if (flexGrid === undefined) {
      messages.push(`データが読み取れません`)
      hasError = true
    } else {
      const data: Array<T主要荷主入力Item> = flexGrid.itemsSource.items
      if (data.length === 0) {
        messages.push(`明細にデータが存在しません`)
        hasError = true
      } else {
        for (let dataIndex in data) {
          const rowData = data[dataIndex]

          // 荷主コードが「なし」は判定しない
          if (data[dataIndex].荷主コード === "") continue
          // 荷主コードが「あり」の場合、詳細内のデータ行をチェック
          for (let tmpDataIndex in data) {
            if (
              tmpDataIndex !== dataIndex &&
              data[tmpDataIndex].荷主コード === data[dataIndex].荷主コード
            ) {
              errorCellPositionList.push({
                行ID: rowData.行ID,
                colBinding: "荷主コード",
              })
              isDetailGridHasFlagError = true
            }
          }
        }
      }
    }

    // フラグでメッセージPush
    if (isDetailGridHasFlagError) {
      messages.push(`同一の部所コード間で、荷主コードが重複しています。`)
      hasError = true
    }

    if (hasError) {
      Form外エラーメッセージList.push(...messages)
      setHasSearched(hasError)
    }
    flexGrid?.refresh()
    return !hasError
  }
  //#endregion

  //#region [effect]

  useEffect(() => {
    document.title = `主要荷主マスタ`
    // 初期表示生成のため画面ロック
    disPatch(画面ロック開始())
  }, [])

  useEffect(() => {
    Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
      set部所ItemSource(部所ListRes.data)
    })
  }, [])

  useEffect(() => {
    if (flexGrid != null) {
      setGridInitialized(true)
    }
  }, [flexGrid])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          disPatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        disPatch(画面ロック解除())
      }
    }
  }, [gridInitialized])

  // error監視
  useEffect(() => {
    if (hasSearched && [...Form外エラーメッセージList].find((e) => e !== "")) {
      disPatch(setWarningAlerts([...Form外エラーメッセージList]))
    }
    setHasSearched(false)
  }, [hasSearched])

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">主要荷主マスタ</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-30rem">
            {/* CardHeaderをアコーディオン化 */}
            {/* 検索項目が登録データのキーになっている為、アコーディオンは表示させる */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={true}>
              <FontAwesomeIcon icon={faChevronDown} size={"1x"} />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    {/* 固定項目 */}
                    <Row>
                      <Col>
                        <div className="w-15rem">
                          <ComboBox.Busyo
                            autoFocus
                            placeholder="部所"
                            isAllSelect={false}
                            itemsSource={部所ItemSource}
                            isLoadEnded={部所IsLoadEnded}
                            setIsLoadEnded={set部所IsLoadEnded}
                            setSelectedValue={set部所コード}
                            listFilter={(d) => d.運行部所フラグ === 1}
                            selectedValue={部所コード}
                            setSelectedItem={set部所}
                            ComboBox={部所ComboBox}
                            setComboBox={set部所ComboBox}></ComboBox.Busyo>
                        </div>
                      </Col>
                      <Col className="text-end">
                        <Button
                          type="submit"
                          disabled={isSearching}
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            search()
                          }}>
                          <FontAwesomeIcon icon={faSearch} />
                          検索
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card className="w-60rem h-100">
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <Row className="grid-header-row">
                <Col>
                  <div>
                    <span>※ １部所で最大１０荷主まで登録可能</span>
                  </div>
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={
                  CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT
                }
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={0}
                gridId={`1`}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                isShowGridRowPickupButton={false}
                isShowGridFooter={false}
                gridProperties={{
                  allowAddNew: false,
                  allowDelete: false,
                  allowSorting: wjcGrid.AllowSorting.None,
                }}>
                <wjrGrid.FlexGridCellTemplate
                  cellType="TopLeft"
                  template={(context: TWijmoCellTemplateContext<any>) => {
                    return (
                      <>
                        <span>No.</span>
                      </>
                    )
                  }}></wjrGrid.FlexGridCellTemplate>
                <wjrGrid.FlexGridCellTemplate
                  cellType="RowHeader"
                  template={(context: TWijmoCellTemplateContext<any>) => {
                    return context.row.index + 1
                  }}
                />
                <wjrGrid.FlexGridColumn
                  binding="荷主コード"
                  width={100}
                  header="荷主CD">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<T主要荷主入力Item>
                    ) => {
                      return (
                        <div className="d-flex justify-content-between">
                          <div className="text-start">
                            {context.item.荷主コード}
                          </div>
                          <div className="text-end">
                            <a
                              href="*"
                              onClick={(e) => {
                                e.preventDefault()
                                if (9 < context.row.index) return
                                set選択行(context.row)
                                setIs荷主検索Modal(true)
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                            </a>
                          </div>
                        </div>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  isReadOnly
                  cssClass="read-only-cell"
                  binding="荷主名"
                  width={300}
                  header="荷主名"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
              <Row>
                <Col>
                  <div>
                    <Button
                      type="button"
                      variant={isSubmitButton ? "waiting" : "secondary"}
                      disabled={!isSubmitButton}
                      onClick={() => {
                        // TODO:登録,Validation,
                        beforeSubmit()
                      }}>
                      登録
                    </Button>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {/* 荷主検索 */}
      <NinusiSearchModal
        size="lg"
        setIsShow={setIs荷主検索Modal}
        isShow={is荷主検索Modal}
        setNinusi={(荷主請求) => {
          if (選択行 == null || 選択行.dataItem == null) return
          const casted: T主要荷主入力Item = 選択行.dataItem
          casted.荷主コード = 荷主請求.荷主コード
          casted.荷主名 = 荷主請求.荷主名

          flexGrid?.refresh()
        }}></NinusiSearchModal>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で更新しますか？
      </ConfirmModal>
    </Container>
  )
}

export default MasterSyuyoNinusiRegister
